import _objectSpread from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
export var sanitizePeriodicWaveOptions = function sanitizePeriodicWaveOptions(options) {
  var imag = options.imag,
      real = options.real;

  if (imag === undefined) {
    if (real === undefined) {
      return _objectSpread({}, options, {
        imag: [0, 0],
        real: [0, 0]
      });
    }

    return _objectSpread({}, options, {
      imag: Array.from(real, function () {
        return 0;
      }),
      real: real
    });
  }

  if (real === undefined) {
    return _objectSpread({}, options, {
      imag: imag,
      real: Array.from(imag, function () {
        return 0;
      })
    });
  }

  return _objectSpread({}, options, {
    imag: imag,
    real: real
  });
};